// **React Imports
import { memo } from 'react'

// **MUI Imports
import { Box, Typography } from '@mui/material'

// **Component Imports
import CustomAvatar from '../avatar'

// **Utils Imports
import { getInitials } from '../../utils/utils'

const UserAvatar = ({ data, sx, src }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '10px',
        width: '100%',
        ...sx
      }}
    >
      <CustomAvatar
        sx={{
          width: 38,
          height: 38,
          fontWeight: 500,
          fontSize: '0.9375rem'
        }}
        {...(src ? { src: src } : {})}
      >
        {getInitials(data?.name || '')}
      </CustomAvatar>
      <Box sx={{ overflow: 'hidden' }}>
        {data?.name && (
          <Typography noWrap className="ellipsis-text">
            {data?.name || ''}
          </Typography>
        )}
        <Typography
          title={data?.email || ''}
          noWrap
          variant="body2"
          className="ellipsis-text"
        >
          {data?.email || ''}
        </Typography>
      </Box>
    </Box>
  )
}

export default memo(UserAvatar)
